export const chart_color_blue_200 = {
  "name": "--pf-chart-color-blue-200",
  "value": "#519de9",
  "var": "var(--pf-chart-color-blue-200, #519de9)"
};
export default chart_color_blue_200;